<template>
  <section class="">
    <div class="wrapper" v-if="!isEditMode">
      <nav class="stepper">
        <ul class="stepper__list">
          <li
            class="stepper__list__item stepper__list__item--done"
            @click="selectStep(1)"
          >
            <span class="relative mb3">
              <i
                title="مشخصات آژانس"
                class="ni ni-building"
              ></i
            ></span>
            <span class="stepper__list__title">1. مشخصات آژانس</span>
          </li>
          <li
            class="stepper__list__item stepper__list__item--done"
            @click="selectStep(2)"
          >
            <span class="relative mb3">
              <i
                :class="{ 'tab-current': !isActiveTab }"
                title="مجوزها"
                class="ni ni-book-bookmark"
              ></i>
            </span>
            <span
              class="stepper__list__title"
              :class="{ 'tab-current': !isActiveTab }"
              >2. مجوزها</span
            >
          </li>
          <li
            class="stepper__list__item stepper__list__item--done"
            @click="selectStep(3)"
          >
            <span class="relative mb3">
              <i
                :class="{ 'tab-current': !isActiveTab }"
                title="بارگذاری مدارک"
                class="ni ni-cloud-download-95"
             ></i
            ></span>
            <span
              class="stepper__list__title"
              :class="{ 'tab-current': !isActiveTab }"
            >
              3. بارگذاری مدارک</span
            >
          </li>
        </ul>
      </nav>
    </div>
     <div class="wrapper"  v-if="isEditMode">
      <nav class="stepper">
        <ul class="stepper__list">
          <li
            class="stepper__list__item stepper__list__item--done"
            @click="selectStep(1)"
          >
            <span class="relative mb3">
              <i
                title="مشخصات آژانس"
                 class="ni ni-building"
              ></i
            ></span>
            <span class="stepper__list__title">1. مشخصات آژانس</span>
          </li>
          <li
            class="stepper__list__item stepper__list__item--done"
            @click="selectStep(2)"
          >
            <span class="relative mb3">
              <i
                title="مجوزها"
                 class="ni ni-book-bookmark"
              ></i>
            </span>
            <span
              class="stepper__list__title"
              >2. مجوزها</span
            >
          </li>
          <li
            class="stepper__list__item stepper__list__item--done"
            @click="selectStep(3)"
          >
            <span class="relative mb3">
              <i
        
                title="بارگذاری مدارک"
                class="ni ni-cloud-download-95"
              ></i
            ></span>
            <span
              class="stepper__list__title"
         
            >
              3. بارگذاری مدارک</span
            >
          </li>
        </ul>
      </nav>
    </div>

    <div>
      <create-agency @activeTabs="activeTabs" v-if="selectedStep === 1" />
      <div v-if="!isEditMode">
        <license v-if="selectedStep === 2 && isActiveTab" />
        <uploadDocumnet v-if="selectedStep === 3 && isActiveTab" />
      </div>
      <div v-if="isEditMode">
        <license v-if="selectedStep === 2" />
        <uploadDocumnet v-if="selectedStep === 3" />
      </div>
    </div>
  </section>
</template>

<script>
import store from "../../views/profile/store/index";
import createAgency from "./CreateAgency";
import license from "./License";
import uploadDocumnet from "./UploadDocument";

export default {
  name: "AgencyStepper",
  store: store,

  components: {
    createAgency,
    license,
    uploadDocumnet,
  },

  data() {
    return {
      selectedStep: 1,
      isActiveTab: false,
      isEditMode: false,
      sourceId: "",
    };
  },
  created() {
    this.sourceId = this.$route.params.sourceId;
    if (this.sourceId != undefined) this.isEditMode = true;
  },

  methods: {
    selectStep(stepper) {
      this.selectedStep = stepper;
    },

    activeTabs(stepper) {
      this.selectedStep = stepper;
      this.isActiveTab = true;
    },
  },
  destroyed() {
    this.$store.commit("SetSourceId", "");
  },
};
</script>

<style  scoped>
body {
  padding: 20px;
  background: #F3F1EE;
}

.wrapper {
  margin-bottom: 30px  !important;
  background: #fff;
}
@media (min-width: 48em) {
  .wrapper {
    max-width: 1500px;
  }
}

.stepper {
  padding: 10px;
  font-size: 16px;
}
@media (min-width: 48em) {
  .stepper {
    padding: 10px;
  }
}
.stepper__list {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style-type: none;
}
@media (min-width: 48em) {
  .stepper__list {
    display: flex;
    justify-content: space-between;
  }
}
.stepper__list__item {
  padding: 3px 5px;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
}
@media (min-width: 48em) {
  .stepper__list__item {
    padding: 10px;
    flex-direction: column;
    flex: 1;
  }
}
.stepper__list__item:after {
  content: "";
  display: block;
  position: absolute;
  z-index: 2;
}
@media (min-width: 48em) {
  .stepper__list__item:after {
    width: calc(100% - 100px);
    top: 28%;
    left: calc(50% + 50px);
    border-top: 2px dotted #E2DFDA;
  }
}
.stepper__list__item--done {
  color: #16294a;
  transition: all .1s;
}
.stepper__list__item--done i{
      color: #2561a4;
}
@media (min-width: 48em) {
  .stepper__list__item--done:after {
    border-top-style: solid;
    border-top-width: 1px;
  }
}
.stepper__list__item--done:hover, .stepper__list__item--done:focus {
  text-decoration: underline;
  cursor: pointer;
}
.stepper__list__item--current {
  color: #006DFF;
}
.stepper__list__item--current:first-of-type:after, .stepper__list__item--current:only-of-type:after {
  height: 30%;
}
.stepper__list__item:first-of-type:after {
  display: none;
}
.stepper__list__item--pending {
  color: #807370;
}
.stepper__list__item--pending:after {
  height: 30%;
}
.stepper__list__title {
  margin: 1px 0 0;
}
@media (min-width: 48em) {
  .stepper__list__title {
    margin: 0;
  }
}
.stepper__list__icon {
  margin: 0 10px 0 0;
  height: 2em;
  width: 2em;
}
@media (min-width: 48em) {
  .stepper__list__icon {
    margin: 0 0 15px;
  }
}
.stepper__list__icon path {
  fill: currentColor;
}
.stepper__list__icon ellipse,
.stepper__list__icon circle {
  stroke: currentColor;
}

.tab-current {
  color:#b0c7b9 !important;
}
</style>  
